import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {contact} from 'config/translate/variables'
import { features } from 'config'
import ItemCategory from './ItemCategory';
import PubSub from "services/PubSub/";
import LoginService from "services/Login/";
import StorageService from 'services/StorageService/';
import DeliverySelector from 'components/Header/DeliverySelector';
import TagManagerService from "services/TagManager";
import { Link } from 'react-router-dom';
import {hasClass, addClass, removeClass, HtmlParse} from "utils";
import UserLinks from './UserLinks';
import logoPrime from 'images/icons/logo-jumbo-prime.svg';
import { useViewportMediaQuery } from 'hooks';
import style from './style.scss';//NOSONAR
import { actionsType } from 'config/constants';

let actions = [];

const MobileMenu = (props) => {
    const [visible, setVisible] = useState(false);
    const [logged, setIsLogged] = useState(false);
    const [firstName, setFirstName] = useState('');
    const dataUser = StorageService.getSecureItem('userData');
    const cencoPrime = dataUser && dataUser.CencoPrime_2020 ? dataUser.CencoPrime_2020 : '';
    const cencoPrimeCat = dataUser && dataUser.CencoPrime_CAT ? dataUser.CencoPrime_CAT : '';
    const isMobile = useViewportMediaQuery(1121)

    useEffect(() => {
        Logged();

        actions.push(PubSub.register('logged_in', changeComponent));
        actions.push(PubSub.register('toggle_menu', closeMenu));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = []
        }
    }, []);

    const changeComponent = (payload) => {
        if (payload.actionType === "logged_in")
            setTimeout(() => Logged(), 500);
    };

    const Logged = () => {
        const userData = StorageService.getSecureItem('userData');

        setIsLogged(LoginService.isLogged());
        setFirstName(userData.firstName);

    };

    const closeMenuUrl = (tag, url, variant) => {
        if(variant){
            TagManagerService.interaction(variant,tag,url);
        }
        else{
            if (typeof (url) === 'string') {
                const title_path = url.replace('/', '').replace('_', ' ');
                const title_crumbs = title_path.charAt(0).toUpperCase() + title_path.slice(1).replace(/-/g, " ");
                TagManagerService.menu(title_crumbs, title_crumbs.split('/').pop(), 'Menú Superior');
            }            
            TagManagerService.clickHeader(tag, url);
        }
        PubSub.dispatch('toggle_menu');
        PubSub.dispatch('toggle_preheader', { state: false })
    }

    const openMenu = () => {
        setVisible(!visible);
        PubSub.dispatch('toggle_minicart', { state: false });
        PubSub.dispatch('toggle_notify', { state: false });
        PubSub.dispatch('toggle_preheader', { state: false })
        PubSub.dispatch(actionsType.DRAWER.MINICART_CLOSE)

        if (typeof window !== 'undefined' && window.innerWidth <= 860) {

            if (!hasClass(document.querySelector('.new-menu-mobile-button'), "active")) {
                addClass(document.documentElement, 'non-scroll');
            } else {
                removeClass(document.documentElement, 'non-scroll');
            }
        }
    }

    const closeMenu = (payload) => {
        const value = payload.value;
        setVisible(value ? value.state : false );
    }

    const categories = props.categories && props.categories.concat(props.fixedCategories);
    if (!isMobile) return '';

    return (
        <>
            <button className={'new-menu-mobile-button' + (visible ? ' active' : '')} onClick={openMenu} aria-label="Mobile menu button">
                <div className="middle-bar"/>
            </button>
            {visible && <div className={'new-mobile-menu'}>
                <div className="triangle-up"/>
                <div className={'new-menu-mobile-overlay'} onClick={openMenu}/>
                <div className={'new-mobile-menu-wrap'} >
                    <div className="new-mobile-user-cenco-prime-container">
                        <span className="user-greet">¡Hola {firstName}!</span>
                        {(cencoPrime || cencoPrimeCat) && features.primeService && <div className="new-header-user-cenco-prime"><i className="logo-prime">{HtmlParse(logoPrime)}</i></div>}
                    </div>
                    <DeliverySelector/>
                    <UserLinks firstName={firstName} logged={logged} closeMenuUrl={closeMenuUrl} offers={props.offers}/>
                    <section className="new-mobile-menu-categories">
                        {(props.offers && props.offers.length > 1) ? (<ItemCategory title={"Ofertas"} categories={props.offers} />)
                            : ( <><Link to={props.offers && props.offers.length && props.offers[0].url} className={'mobile-offers-link'} onClick={()=>closeMenuUrl('Ver Ofertas','/mis-datos')}>Ver Ofertas</Link>
                            </>) }
                        <ItemCategory categories={categories} />
                    </section>
                    <section className="new-mobile-menu-footer">
                        <a href={`tel:${contact.phone}`} className="new-menu-mobile-phone"><i className="jumbo-icon-new-phone" />Llámanos</a>
                    </section>
                </div>
            </div>}
        </>
    )
}

MobileMenu.propTypes = {
    categories: PropTypes.array,
    fixedCategories: PropTypes.array,
    offers : PropTypes.array
};

export default MobileMenu;
